// Auth callbacks must return synchronously: database calls may need the very
// session lock that Supabase holds until the callback returns.
export function createDeferredAuthListener({ onSession, onSignedIn, onError }) {
  let disposed = false;
  let generation = 0;
  let timer;
  let identity = null;
  return {
    handle(event, session) {
      if (disposed) return;
      onSession(session);
      const nextIdentity = session?.user?.id || null;
      const identityChanged = nextIdentity !== identity;
      const validatesSession = event === 'SIGNED_IN' || event === 'INITIAL_SESSION' || identityChanged;
      if (event === 'SIGNED_OUT' || validatesSession) {
        identity = nextIdentity;
        generation += 1;
        clearTimeout(timer);
      }
      if (!validatesSession || !session) return;
      const current = generation;
      const isCurrent = () => !disposed && current === generation;
      timer = setTimeout(() => {
        if (!isCurrent()) return;
        Promise.resolve().then(() => isCurrent() && onSignedIn(session, isCurrent))
          .catch(error => { if (isCurrent()) onError(error); });
      }, 0);
    },
    dispose() {
      disposed = true;
      generation += 1;
      clearTimeout(timer);
    },
  };
}
